
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, { get: v, set: s, enumerable: true, configurable: true });
}
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */ var $77905d37f201803f$export$4473561af957c5c7;
(function (BLOCKS) {
  BLOCKS["DOCUMENT"] = "document";
  BLOCKS["PARAGRAPH"] = "paragraph";
  BLOCKS["HEADING_1"] = "heading-1";
  BLOCKS["HEADING_2"] = "heading-2";
  BLOCKS["HEADING_3"] = "heading-3";
  BLOCKS["HEADING_4"] = "heading-4";
  BLOCKS["HEADING_5"] = "heading-5";
  BLOCKS["HEADING_6"] = "heading-6";
  BLOCKS["OL_LIST"] = "ordered-list";
  BLOCKS["UL_LIST"] = "unordered-list";
  BLOCKS["LIST_ITEM"] = "list-item";
  BLOCKS["HR"] = "hr";
  BLOCKS["QUOTE"] = "blockquote";
  BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
  BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
  BLOCKS["EMBEDDED_RESOURCE"] = "embedded-resource-block";
  BLOCKS["TABLE"] = "table";
  BLOCKS["TABLE_ROW"] = "table-row";
  BLOCKS["TABLE_CELL"] = "table-cell";
  BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})($77905d37f201803f$export$4473561af957c5c7 || ($77905d37f201803f$export$4473561af957c5c7 = {}));


/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 */ var $4d7ce215333839fa$export$6dca1cbf5d592fbd;
(function (INLINES) {
  INLINES["HYPERLINK"] = "hyperlink";
  INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
  INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
  INLINES["RESOURCE_HYPERLINK"] = "resource-hyperlink";
  INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
  INLINES["EMBEDDED_RESOURCE"] = "embedded-resource-inline";
})($4d7ce215333839fa$export$6dca1cbf5d592fbd || ($4d7ce215333839fa$export$6dca1cbf5d592fbd = {}));


/**
 * Map of all Contentful marks.
 */ var $730e5cb8a3709e92$export$c85f128c9305332e;
(function (MARKS) {
  MARKS["BOLD"] = "bold";
  MARKS["ITALIC"] = "italic";
  MARKS["UNDERLINE"] = "underline";
  MARKS["CODE"] = "code";
  MARKS["SUPERSCRIPT"] = "superscript";
  MARKS["SUBSCRIPT"] = "subscript";
  MARKS["STRIKETHROUGH"] = "strikethrough";
})($730e5cb8a3709e92$export$c85f128c9305332e || ($730e5cb8a3709e92$export$c85f128c9305332e = {}));


var $54ae2f86adcd9110$exports = {};

$parcel$export($54ae2f86adcd9110$exports, "TOP_LEVEL_BLOCKS", () => $54ae2f86adcd9110$export$ba32543429ed7e1c);
$parcel$export($54ae2f86adcd9110$exports, "LIST_ITEM_BLOCKS", () => $54ae2f86adcd9110$export$f164f8df1f226ed8);
$parcel$export($54ae2f86adcd9110$exports, "TABLE_BLOCKS", () => $54ae2f86adcd9110$export$61dc594370225b3);
$parcel$export($54ae2f86adcd9110$exports, "VOID_BLOCKS", () => $54ae2f86adcd9110$export$85f9856e66f16aa5);
$parcel$export($54ae2f86adcd9110$exports, "CONTAINERS", () => $54ae2f86adcd9110$export$f31e81340f60ac4f);
$parcel$export($54ae2f86adcd9110$exports, "HEADINGS", () => $54ae2f86adcd9110$export$7b02abc60d9af577);
$parcel$export($54ae2f86adcd9110$exports, "TEXT_CONTAINERS", () => $54ae2f86adcd9110$export$33c1f54ccb4cc9b7);
$parcel$export($54ae2f86adcd9110$exports, "V1_NODE_TYPES", () => $54ae2f86adcd9110$export$f8a6793e9df3d55d);
$parcel$export($54ae2f86adcd9110$exports, "V1_MARKS", () => $54ae2f86adcd9110$export$d8b073923a26e49d);



const $54ae2f86adcd9110$export$ba32543429ed7e1c = [
  (0, $77905d37f201803f$export$4473561af957c5c7).PARAGRAPH,
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_1,
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_2,
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_3,
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_4,
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_5,
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_6,
  (0, $77905d37f201803f$export$4473561af957c5c7).OL_LIST,
  (0, $77905d37f201803f$export$4473561af957c5c7).UL_LIST,
  (0, $77905d37f201803f$export$4473561af957c5c7).HR,
  (0, $77905d37f201803f$export$4473561af957c5c7).QUOTE,
  (0, $77905d37f201803f$export$4473561af957c5c7).EMBEDDED_ENTRY,
  (0, $77905d37f201803f$export$4473561af957c5c7).EMBEDDED_ASSET,
  (0, $77905d37f201803f$export$4473561af957c5c7).EMBEDDED_RESOURCE,
  (0, $77905d37f201803f$export$4473561af957c5c7).TABLE
];
const $54ae2f86adcd9110$export$f164f8df1f226ed8 = [
  (0, $77905d37f201803f$export$4473561af957c5c7).PARAGRAPH,
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_1,
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_2,
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_3,
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_4,
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_5,
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_6,
  (0, $77905d37f201803f$export$4473561af957c5c7).OL_LIST,
  (0, $77905d37f201803f$export$4473561af957c5c7).UL_LIST,
  (0, $77905d37f201803f$export$4473561af957c5c7).HR,
  (0, $77905d37f201803f$export$4473561af957c5c7).QUOTE,
  (0, $77905d37f201803f$export$4473561af957c5c7).EMBEDDED_ENTRY,
  (0, $77905d37f201803f$export$4473561af957c5c7).EMBEDDED_ASSET,
  (0, $77905d37f201803f$export$4473561af957c5c7).EMBEDDED_RESOURCE
];
const $54ae2f86adcd9110$export$61dc594370225b3 = [
  (0, $77905d37f201803f$export$4473561af957c5c7).TABLE,
  (0, $77905d37f201803f$export$4473561af957c5c7).TABLE_ROW,
  (0, $77905d37f201803f$export$4473561af957c5c7).TABLE_CELL,
  (0, $77905d37f201803f$export$4473561af957c5c7).TABLE_HEADER_CELL
];
const $54ae2f86adcd9110$export$85f9856e66f16aa5 = [
  (0, $77905d37f201803f$export$4473561af957c5c7).HR,
  (0, $77905d37f201803f$export$4473561af957c5c7).EMBEDDED_ENTRY,
  (0, $77905d37f201803f$export$4473561af957c5c7).EMBEDDED_ASSET,
  (0, $77905d37f201803f$export$4473561af957c5c7).EMBEDDED_RESOURCE
];
const $54ae2f86adcd9110$export$f31e81340f60ac4f = {
  [(0, $77905d37f201803f$export$4473561af957c5c7).OL_LIST]: [
    (0, $77905d37f201803f$export$4473561af957c5c7).LIST_ITEM
  ],
  [(0, $77905d37f201803f$export$4473561af957c5c7).UL_LIST]: [
    (0, $77905d37f201803f$export$4473561af957c5c7).LIST_ITEM
  ],
  [(0, $77905d37f201803f$export$4473561af957c5c7).LIST_ITEM]: $54ae2f86adcd9110$export$f164f8df1f226ed8,
  [(0, $77905d37f201803f$export$4473561af957c5c7).QUOTE]: [
    (0, $77905d37f201803f$export$4473561af957c5c7).PARAGRAPH
  ],
  [(0, $77905d37f201803f$export$4473561af957c5c7).TABLE]: [
    (0, $77905d37f201803f$export$4473561af957c5c7).TABLE_ROW
  ],
  [(0, $77905d37f201803f$export$4473561af957c5c7).TABLE_ROW]: [
    (0, $77905d37f201803f$export$4473561af957c5c7).TABLE_CELL,
    (0, $77905d37f201803f$export$4473561af957c5c7).TABLE_HEADER_CELL
  ],
  [(0, $77905d37f201803f$export$4473561af957c5c7).TABLE_CELL]: [
    (0, $77905d37f201803f$export$4473561af957c5c7).PARAGRAPH
  ],
  [(0, $77905d37f201803f$export$4473561af957c5c7).TABLE_HEADER_CELL]: [
    (0, $77905d37f201803f$export$4473561af957c5c7).PARAGRAPH
  ]
};
const $54ae2f86adcd9110$export$7b02abc60d9af577 = [
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_1,
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_2,
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_3,
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_4,
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_5,
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_6
];
const $54ae2f86adcd9110$export$33c1f54ccb4cc9b7 = [
  (0, $77905d37f201803f$export$4473561af957c5c7).PARAGRAPH,
  ...$54ae2f86adcd9110$export$7b02abc60d9af577
];
const $54ae2f86adcd9110$export$f8a6793e9df3d55d = [
  (0, $77905d37f201803f$export$4473561af957c5c7).DOCUMENT,
  (0, $77905d37f201803f$export$4473561af957c5c7).PARAGRAPH,
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_1,
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_2,
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_3,
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_4,
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_5,
  (0, $77905d37f201803f$export$4473561af957c5c7).HEADING_6,
  (0, $77905d37f201803f$export$4473561af957c5c7).OL_LIST,
  (0, $77905d37f201803f$export$4473561af957c5c7).UL_LIST,
  (0, $77905d37f201803f$export$4473561af957c5c7).LIST_ITEM,
  (0, $77905d37f201803f$export$4473561af957c5c7).HR,
  (0, $77905d37f201803f$export$4473561af957c5c7).QUOTE,
  (0, $77905d37f201803f$export$4473561af957c5c7).EMBEDDED_ENTRY,
  (0, $77905d37f201803f$export$4473561af957c5c7).EMBEDDED_ASSET,
  (0, $4d7ce215333839fa$export$6dca1cbf5d592fbd).HYPERLINK,
  (0, $4d7ce215333839fa$export$6dca1cbf5d592fbd).ENTRY_HYPERLINK,
  (0, $4d7ce215333839fa$export$6dca1cbf5d592fbd).ASSET_HYPERLINK,
  (0, $4d7ce215333839fa$export$6dca1cbf5d592fbd).EMBEDDED_ENTRY,
  "text"
];
const $54ae2f86adcd9110$export$d8b073923a26e49d = [
  (0, $730e5cb8a3709e92$export$c85f128c9305332e).BOLD,
  (0, $730e5cb8a3709e92$export$c85f128c9305332e).CODE,
  (0, $730e5cb8a3709e92$export$c85f128c9305332e).ITALIC,
  (0, $730e5cb8a3709e92$export$c85f128c9305332e).UNDERLINE
];


var $b2dd4c5c8392e92d$exports = {};


var $df4ba68e57928a75$exports = {};



const $c026fa2e7f55fadf$export$e5cde5f1d56fabad = {
  nodeType: (0, $77905d37f201803f$export$4473561af957c5c7).DOCUMENT,
  data: {},
  content: [
    {
      nodeType: (0, $77905d37f201803f$export$4473561af957c5c7).PARAGRAPH,
      data: {},
      content: [
        {
          nodeType: "text",
          value: "",
          marks: [],
          data: {}
        }
      ]
    }
  ]
};


var $72ab8144fb7390e4$exports = {};

$parcel$export($72ab8144fb7390e4$exports, "isInline", () => $72ab8144fb7390e4$export$ff307ae11ac2408e);
$parcel$export($72ab8144fb7390e4$exports, "isBlock", () => $72ab8144fb7390e4$export$de5a9e42c1dff8da);
$parcel$export($72ab8144fb7390e4$exports, "isText", () => $72ab8144fb7390e4$export$1879817ac5c922b7);


/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */ function $72ab8144fb7390e4$var$hasValue(obj, value) {
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
  try {
    for (var _iterator = Object.keys(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      const key = _step.value;
      if (value === obj[key]) return true;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return false;
}
function $72ab8144fb7390e4$export$ff307ae11ac2408e(node) {
  return $72ab8144fb7390e4$var$hasValue((0, $4d7ce215333839fa$export$6dca1cbf5d592fbd), node.nodeType);
}
function $72ab8144fb7390e4$export$de5a9e42c1dff8da(node) {
  return $72ab8144fb7390e4$var$hasValue((0, $77905d37f201803f$export$4473561af957c5c7), node.nodeType);
}
function $72ab8144fb7390e4$export$1879817ac5c922b7(node) {
  return node.nodeType === "text";
}




export { $77905d37f201803f$export$4473561af957c5c7 as BLOCKS, $4d7ce215333839fa$export$6dca1cbf5d592fbd as INLINES, $730e5cb8a3709e92$export$c85f128c9305332e as MARKS, $c026fa2e7f55fadf$export$e5cde5f1d56fabad as EMPTY_DOCUMENT, $54ae2f86adcd9110$export$ba32543429ed7e1c as TOP_LEVEL_BLOCKS, $54ae2f86adcd9110$export$f164f8df1f226ed8 as LIST_ITEM_BLOCKS, $54ae2f86adcd9110$export$61dc594370225b3 as TABLE_BLOCKS, $54ae2f86adcd9110$export$85f9856e66f16aa5 as VOID_BLOCKS, $54ae2f86adcd9110$export$f31e81340f60ac4f as CONTAINERS, $54ae2f86adcd9110$export$7b02abc60d9af577 as HEADINGS, $54ae2f86adcd9110$export$33c1f54ccb4cc9b7 as TEXT_CONTAINERS, $54ae2f86adcd9110$export$f8a6793e9df3d55d as V1_NODE_TYPES, $54ae2f86adcd9110$export$d8b073923a26e49d as V1_MARKS };
//# sourceMappingURL=index.mjs.map
